import React from 'react';
import './style.scss';
import useUpdateProfile from './hook';
import Popup from '../../Components/Popup';
import { Editor } from '@tinymce/tinymce-react';

const UpdateProfile = () => {
  const {
    handleOnChangeForm,
    formData,
    handleUpdateProfile,
    handleEditor,
    error,
    setIsShowPopup,
    isShowPopup,
  } = useUpdateProfile();

  return (
    <>
      <div className='admin-news'>
        <div className='header-content row'>
          <div className='title-page col-md-8 col-s-12'>Cập nhật thông tin</div>
          <button
            type='button'
            className='btn btn-primary desktop-only'
            onClick={handleUpdateProfile}
          >
            Lưu thay đổi
          </button>
        </div>
        <div className='admin-news-controll'>
          <div className='admin-news-content'>
            <div className='row justify-content-center mt-30'>
              <div className='spline-chart col-xl-12 col-md-12 mb-12'>
                <div className='card shadow '>
                  <div className='card-body input-news'>
                    {/* <h6 className='m-0 font-weight-bold text-primary  d-block mb-3'>
                        Link logo
                      </h6>
                      <input
                        className='form-control mr-sm-2'
                        placeholder='Nhập link logo của bạn  ... '
                        value={formData?.thumbnail || ''}
                        onChange={(e) => {
                          handleOnChangeForm(e.target.value, 'thumbnail');
                        }}
                      /> */}
                    <div className='input-group'>
                      <h6 className='m-0 font-weight-bold text-primary  d-block mb-3'>
                        Ảnh hiển thị (126px x 126px)
                      </h6>
                      <label htmlFor='image-upload'>
                        <div className='image-show'>
                          <div
                            style={{
                              backgroundImage: `url(${formData?.thumbnail})`,
                            }}
                            className={
                              formData?.thumbnail && 'image-upload-show'
                            }
                          />
                          <div
                            className={`placeholder ${
                              formData?.thumbnail && 'placeholder-hover'
                            } `}
                          >
                            Tải ảnh lên
                          </div>
                        </div>
                        <input
                          type='file'
                          id='image-upload'
                          accept='image/png,image/jpg,image/jpeg,image/svg'
                          className='input-upload'
                          onChange={(e) => {
                            handleOnChangeForm(e, 'thumbnail');
                          }}
                        />
                      </label>
                    </div>
                    <div className='input-group'>
                      <h6 className='m-0 font-weight-bold text-primary d-block mb-3'>
                        Ảnh hồ sơ (126px x 64px)
                      </h6>
                      <label htmlFor='image-upload-2'>
                        <div className='image-show'>
                          <div
                            style={{
                              backgroundImage: `url(${formData?.profile_img})`,
                            }}
                            className={
                              formData?.profile_img && 'image-upload-show'
                            }
                          />
                          <div
                            className={`placeholder ${
                              formData?.profile_img && 'placeholder-hover'
                            } `}
                          >
                            Tải ảnh lên
                          </div>
                        </div>
                        <input
                          type='file'
                          id='image-upload-2'
                          accept='image/png,image/jpg,image/jpeg,image/svg'
                          className='input-upload'
                          onChange={(e) => {
                            handleOnChangeForm(e, 'profile_img');
                          }}
                        />
                      </label>
                    </div>
                    <div className='input-group'>
                      <div className='d-flex justify-content-between w-100'>
                        <h6 className='m-0 font-weight-bold text-primary  d-block mb-3'>
                          Giới thiệu ngắn(tối đa 200 ký tự)
                        </h6>
                        <div>
                          {formData && formData.shortDescription
                            ? formData.shortDescription.length
                            : '0'}
                          /200
                        </div>
                      </div>
                      <textarea
                        className='form-control mr-sm-2 '
                        placeholder='Nhập mô tả tin tức ngắn gọn ... '
                        value={formData && formData.shortDescription}
                        onChange={(e) => {
                          handleOnChangeForm(e, 'shortDescription');
                        }}
                      ></textarea>
                    </div>
                    <h6 className='m-0 font-weight-bold text-primary  d-block mb-3'>
                      Thông tin chi tiết
                    </h6>
                    <div className='text-editor'>
                      {/* <JoditEditor
                        value={formData?.description || ''}
                        ref={refEditor}
                      /> */}
                      <Editor
                        apiKey='wedeol2skpvc4bytkplszwedv99192bzjarzkc8g5wn4ef1l'
                        // onInit={(evt, editor) => (editorRef.current = editor)}
                        initialValue={formData && formData.description}
                        onEditorChange={(value) => handleEditor(value)}
                        onNodeChange={(e) => {
                          if (e.element.nodeName.toLowerCase() === 'img') {
                            console.log('==', e.element.width);
                            e.element.setAttribute('width', '100%');
                            e.element.setAttribute('height', 'auto');
                          }
                        }}
                        init={{
                          height: 500,
                          menubar: false,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | ' +
                            'bold italic backcolor | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | ' +
                            'removeformat | image | table',
                          content_style:
                            'img {max-width: 100%; width: 100%; height: auto;}',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className='mobile-only'
          style={{ position: 'fixed', bottom: '0', width: '100%' }}
        >
          <button
            type='button'
            className='btn btn-primary'
            style={{ width: '100%', boderRadius: '0' }}
            onClick={handleUpdateProfile}
          >
            Lưu thay đổi
          </button>
        </div>
      </div>
      {isShowPopup && (
        <Popup
          title={error?.title}
          body={error?.body}
          handle={error?.onHandle}
          labelButton='OK'
          onClosePopup={() => {
            setIsShowPopup(false);
          }}
        />
      )}
    </>
  );
};

export default UpdateProfile;
